import { observer } from 'mobx-react-lite'
import { TableHost } from '@/components/Table'
import { WorkspaceFilterViewHeadingContainer } from '@/components/WorkspaceFilterViewHeadingContainer'
import { VirtualTableContainer } from '@/components/VirtualTableContainer'
import { NoResultsEmptyState } from '@/components/NoResultsEmptyState'
import { DocumentCountContainer } from '@/features/documents/components/DocumentManagementTable/DocumentCount/DocumentCountContainer'
import { DocumentManagementFilterViewerContainer } from '@/features/documents/components/DocumentManagementTable/DocumentManagementFilterViewer/DocumentManagementFilterViewerContainer'
import { DocumentManagementTableHeaderRowContainer } from '@/features/documents/components/DocumentManagementTable/DocumentManagementTableHeaderRow/DocumentManagementTableHeaderRowContainer'
import { DeleteDocumentsDialogContainer } from '@/features/documents/components/DocumentManagementTable/DeleteDocumentsDialog/DeleteDocumentsDialogContainer'
import { DocumentManagementTableRowContainer } from '@/features/documents/components/DocumentManagementTable/DocumentManagementTableRow/DocumentManagementTableRowContainer'
import { type DocumentsTabViewModel } from '@/features/documents/DocumentsTabViewModel'
import { DocumentsTab } from '@/features/documents/components/DocumentsTab'
import { useFeatures } from '@/contexts/root-store-context'

export interface DocumentsTabContainerProps {
  vm: DocumentsTabViewModel
}

export const DocumentsTabContainer = observer(function DocumentsTabContainer({
  vm,
}: DocumentsTabContainerProps) {
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))
  return (
    <DocumentsTab
      workspaceFilter={
        <WorkspaceFilterViewHeadingContainer
          allOptionText="All Workspaces"
          primaryText=""
          filter={vm.documentManagementVm.searcher.workspacesFilter}
          viewHeadingSize="small"
          testId="workspace-filter-view-heading-dropdown"
        />
      }
      documentCount={<DocumentCountContainer vm={vm.documentManagementVm} />}
    >
      <TableHost>
        <DocumentManagementFilterViewerContainer vm={vm.documentManagementVm} />

        {!vm.shouldShowEmptyState ? (
          <VirtualTableContainer
            overscan={50}
            scroller={vm.documentManagementVm.searcher.scroller}
            data={vm.documentManagementVm.rowVms}
            headerContent={() => (
              <DocumentManagementTableHeaderRowContainer
                vm={vm.documentManagementVm}
              />
            )}
            itemContent={(_index, rowVm) => (
              <DocumentManagementTableRowContainer
                vm={rowVm}
                columns={vm.documentManagementVm.columns}
              />
            )}
          />
        ) : (
          <NoResultsEmptyState
            corporateMode={shellInfo.corporateMode}
            isSearchFilterApplied={vm.isSearchFilterApplied}
            onClearSearchFilter={vm.clearFilters}
          />
        )}

        <DeleteDocumentsDialogContainer
          vm={vm.documentManagementVm.deleteDialogVm}
        />
      </TableHost>
    </DocumentsTab>
  )
})
